import { render, staticRenderFns } from "./FR.vue?vue&type=template&id=15a453ee&scoped=true&"
import script from "./FR.vue?vue&type=script&lang=js&"
export * from "./FR.vue?vue&type=script&lang=js&"
import style0 from "./FR.vue?vue&type=style&index=0&id=15a453ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a453ee",
  null
  
)

export default component.exports